import { Component, OnInit, ViewChild } from '@angular/core';

import { CompanyName } from 'src/app/business/models/master/company/company-name.model';
import { ProviderGuideInteractor } from 'src/app/domain/interactor/provider/guide.interactor';
import { ServerErrorManager } from 'src/app/ui/components/utils/server-error-manager.utils';
import { GenericException } from 'src/app/domain/exceptions/generic.exception';
import { MessagePanelComponent } from 'src/app/ui/components/shared/message-panel/message-panel.component';
import { ProviderBillingInteractor } from 'src/app/domain/interactor/provider/billing.interactor';
import { ChunkGeneric } from 'src/app/domain/views/chunk-generic.view';
import { GuideServiceDetails } from 'src/app/business/models/billing/service-details.model';
import { NavigationConstants } from 'src/app/ui/commons/navigation.constants';
import { Router } from '@angular/router';
import { marker as I18N } from '@biesbjerg/ngx-translate-extract-marker';
import { ProviderGuideServiceInteractor } from 'src/app/domain/interactor/provider/guide-service.interactor';
import { GuideServiceState } from 'src/app/business/models/billing/common/guide-service-state.constants';
import { FindServicesFilterView } from 'src/app/domain/views/services/find-services-filter.view';
import { GuideServiceStats } from 'src/app/business/models/billing/service-stats.model';


@Component({
     selector: 'app-guide-list-service-provider',
     templateUrl: './list.component.html'
})
export class ProviderListGuideServiceComponent implements OnInit {

     @ViewChild(MessagePanelComponent)
     private messagePanelComponent: MessagePanelComponent;

     guides: Array<CompanyName>;
     guideServices: ChunkGeneric<GuideServiceDetails>;

     guideServiceStats: GuideServiceStats;

     findCommissionsFilterView: FindServicesFilterView;

     constructor(
          private providerGuideInteractor: ProviderGuideInteractor,
          private providerGuideServicesInteractor: ProviderGuideServiceInteractor,
          private serverErrorManager: ServerErrorManager,
          private router: Router
     ) {

     }

     ngOnInit() {
          this.providerGuideInteractor.getGuidesNames()
          .subscribe(
               ( guides: Array<CompanyName> ) => {
                    this.guides = guides;
               },
               (error: GenericException) => {
                    this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);

               }
          )
     }

     onFilterCommissions(findCommissionsFilterView: FindServicesFilterView) {

          this.findCommissionsFilterView = findCommissionsFilterView;
          this.findGuideServices();

     }



     findGuideServices() {
          
          if ( this.messagePanelComponent ) {
               this.messagePanelComponent.showLoading();
          }

          this.providerGuideServicesInteractor.findGuideServices(this.findCommissionsFilterView.month, this.findCommissionsFilterView.year, this.findCommissionsFilterView.guideId, this.findCommissionsFilterView.state, this.findCommissionsFilterView.pageNumber)
          .subscribe(
               ( commissions: ChunkGeneric<GuideServiceDetails> ) => {
                    this.guideServices = commissions;
                    MessagePanelComponent.hideLoading();
               },
               (error: GenericException) => {
                    MessagePanelComponent.hideLoading();
                    this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);

               }
          )


          this.providerGuideServicesInteractor.findGuideServicesStats(this.findCommissionsFilterView.month, this.findCommissionsFilterView.year, this.findCommissionsFilterView.guideId)
          .subscribe(
               ( guideServiceStats: GuideServiceStats ) => {
                    this.guideServiceStats = guideServiceStats;
               },
               (error: GenericException) => {
                    MessagePanelComponent.hideLoading();
                    this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);

               }
          )

     }


     onCreateCommission() {
          this.router.navigate( [ NavigationConstants.getNavigationProviderGuideServiceCreate() ] );
     }




     onApproveService(commissionId: number) {

          this.messagePanelComponent.showConfirmationMessage(I18N('serviceslist.¿Seguro que quieres aprobar el servicio?'), () => {

               this.messagePanelComponent.showLoading();

               this.providerGuideServicesInteractor.approveService(commissionId)
               .subscribe(
                    ( ) => {
                         this.guideServices.items.forEach(function(guideService: GuideServiceDetails) {
                              if ( guideService.id == commissionId ) {
                                   guideService.state = GuideServiceState.Approved;
                              }
                         })
                         MessagePanelComponent.hideLoading();
                         this.findGuideServices();
                    },
                    (error: GenericException) => {
                         MessagePanelComponent.hideLoading();
                         this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);

                    }
               )

          });
          
          
     }

     onEditService(commissionId: number) {
          this.router.navigate( [ NavigationConstants.getNavigationProviderGuideServiceUpdate(commissionId) ] );
     }

     onDeleteService(commissionId: number) {


          this.messagePanelComponent.showConfirmationMessage(I18N('serviceslist.¿Seguro que quieres borrar el servicio?'), () => {

               this.messagePanelComponent.showLoading();

               this.providerGuideServicesInteractor.deleteService(commissionId)
               .subscribe(
                    ( ) => {
                         this.guideServices.items.forEach(function(guideService: GuideServiceDetails) {
                              if ( guideService.id == commissionId ) {
                                   guideService.state = GuideServiceState.Deleted;
                              }
                         })
                         MessagePanelComponent.hideLoading();
                         this.findGuideServices();
                    },
                    (error: GenericException) => {
                         MessagePanelComponent.hideLoading();
                         this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);

                    }
               )

          });


          

     }

}